module.exports = __webpack_public_path__ + "static/media/JMSS.8efdc485.svg";